import { trackClick } from 'Services/SselTrackingService';

const parseContext = (raw) => {
  if (!raw) return undefined;

  try {
    return JSON.parse(raw);
  } catch {
    return undefined;
  }
};

const parsePosition = (raw) => {
  if (raw === undefined) return undefined;

  const parsed = parseInt(raw, 10);
  return Number.isNaN(parsed) ? undefined : parsed;
};

const resolveTargetUrl = (target) => {
  if (target.dataset.sselTargetUrl) return target.dataset.sselTargetUrl;

  const link = target.closest('a');
  return link ? link.href : undefined;
};

const slugifyPageType = (pageType) => {
  if (!pageType) return undefined;

  return pageType.trim().toLowerCase().replace(/\s+/g, '_');
};

const resolveUnifiedPageType = () => {
  if (typeof window === 'undefined') return undefined;

  return slugifyPageType(window.dataLayer?.[0]?.page?.pageType);
};

export const handleSselClick = (event, referenceEventId) => {
  const eventTarget = event?.target;
  if (!eventTarget || typeof eventTarget.closest !== 'function') return;

  const target = eventTarget.closest('[data-ssel-click]');
  if (!target) return;

  trackClick({
    clickType: target.dataset.sselClick,
    referenceEventId,
    targetUrl: resolveTargetUrl(target),
    label: target.dataset.sselLabel,
    position: parsePosition(target.dataset.sselPosition),
    context: parseContext(target.dataset.sselContext),
    pageType: target.dataset.sselPageType || resolveUnifiedPageType(),
  });
};

let cachedReferenceEventId;

// For activations the delegated click listener can't see (e.g. Enter or
// middle-click on a MaskedLink). Never throws, so callers can use it in
// navigation paths.
export const trackSselClick = (fields) => {
  try {
    trackClick({
      referenceEventId: cachedReferenceEventId,
      pageType: resolveUnifiedPageType(),
      ...fields,
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('[sselClickTracker] click tracking failed ❌', error);
  }
};

export const initSselClickTracking = () => {
  if (typeof document === 'undefined') return;

  const referenceEventId = window.__INITIAL_STATE__?.requestData?.requestId;
  cachedReferenceEventId = referenceEventId;

  document.addEventListener('click', (event) =>
    handleSselClick(event, referenceEventId)
  );
};
